import { render, staticRenderFns } from "./LessonFiles.vue?vue&type=template&id=ef16c6ac&"
import script from "./LessonFiles.vue?vue&type=script&lang=js&"
export * from "./LessonFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports